import "../../../../lib/store/createAppApi.js";
import "../../../../lib/store/createAppAsyncThunk.js";
import { createAppSelector } from "../../../../lib/store/createAppSelector.js";
import "../../../../lib/store/createAppSlice.js";
import "react";
import "redux";
import "../../../../lib/store/hooks/useAppDispatch.js";
import "../../../../lib/store/hooks/useAppSelector.js";
import "../../../../lib/store/hooks/useAppStore.js";
import { selectSlice } from "./selectSlice.js";
const selectCredit = createAppSelector(selectSlice, (config) => {
  const { credit } = config;
  return {
    ...credit,
    enable: (credit == null ? void 0 : credit.enable) ?? false
  };
});
export {
  selectCredit
};
